<template>
    <div class="catalog-container">
        <FormCatalogToolbar
            @expand="collapse = -Math.random()"
            @collapse="collapse = Math.random()"
            class="catalog-toolbar"/>

        <div class="catalog-tree">
            <draggable
                v-model="list"
                @change="onReorder"
                :animation="0"
                class="p-2"
                ghostClass="ghost">
                <transition-group type="transition" name="flip-list">
                    <div v-for="section in sections" :key="section.key">
                        <DocSubtypeSettingsCatalogSection
                            :section="section"
                            :fields="fields.filter(f => f.section.key === section.key)"
                            :selection="selection"
                            :collapse="collapse"
                            :changeSelection="changeSelection"
                            :updateFields="updateFields"/>
                    </div>
                </transition-group>
            </draggable>
        </div>

        <slot name="catalog-footer"></slot>

        <!-- modals -->
        <AddFormSection name="add-form-section" :sections="sections" @add="onSectionAdd"/>
        <AddFormField name="add-form-field" :sections="sections" :fields="fields" @add="onFieldAdd"/>
    </div>
</template>
<script>
import draggable from 'vuedraggable'
import DocSubtypeSettingsCatalogSection from './FormCatalogSection'
import FormCatalogToolbar from './FormCatalogToolbar'
import AddFormSection from '../create/AddFormSection'
import AddFormField from '../create/AddFormField'

export default {
    name: 'FormCatalog',
    props: {
        sections: {
            type: Array,
            required: true
        },
        fields: {
            type: Array,
            required: true
        },
        selection: {
            type: Object,
            required: true
        },
        updateSections: {
            type: Function,
            required: true
        },
        updateFields: {
            type: Function,
            required: true
        },
        changeSelection: {
            type: Function,
            required: true
        }
    },
    data() {
        return {
            list: null,
            collapse: 1 // negative value to expand
        }
    },
    components: {
        AddFormField,
        AddFormSection,
        FormCatalogToolbar,
        DocSubtypeSettingsCatalogSection,
        draggable
    },
    methods: {
        onReorder() {
            const updatedSection = this.list.map((s, idx) => ({...s, order: idx}))
            this.updateSections(updatedSection)
        },

        async onSectionAdd(section) {
            const sections = _.cloneDeep(this.sections)
            sections.push(section)
            this.updateSections(sections)
            await this.$nextTick()
            this.changeSelection({section: section.key})
        },

        async onFieldAdd(field) {
            const fields = _.cloneDeep(this.fields)
            fields.push(field)
            this.updateFields(fields)
            await this.$nextTick()
            this.changeSelection({section: field.section.key, field: field.path})
        }
    },
    watch: {
        sections: {
            handler(list) {
                this.list = list
            },
            deep: true,
            immediate: true
        }
    }
}
</script>

<style lang="scss" scoped>
    .catalog-container {
        display: flex;
        flex-direction: column;
        background: $color-white-muted;
        height: 100%;

        .catalog-toolbar {
            height: 34px;
        }

        .catalog-tree {
            flex: auto;
            overflow-y: auto;
        }
    }
</style>

<style lang="scss">
    .flip-list-move {
        transition: transform 0.5s;
    }

    .ghost {
        opacity: 0.5;
        background: #c8ebfb;
    }
</style>
